import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';

import { ProfilesApiService } from '~/api/profiles/profiles-api.service';
import { UsersApiService } from '~/api/users/users-api.service';

import { SKIP_NAMESPACE_TOKEN } from './skip-namespace.token';

export const namespaceInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UsersApiService);
  const workspace = inject(ProfilesApiService).currentWorkspace$.value?.namespace;

  if (!workspace) {
    return next(req);
  }

  return userService.user$.pipe(
    switchMap((user) => {
      if (!user?.roles?.admin || req.context.has(SKIP_NAMESPACE_TOKEN)) {
        return next(req);
      }

      return next(req.clone({ headers: req.headers.set('x-namespace', workspace) }));
    }),
  );
};
